var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankSubmittedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.416,
    height: 64.416,
    rx: 32.208,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7896 41.0996V41.9666C20.7896 42.4442 21.1762 42.8316 21.6537 42.8316H31.2699",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4272 20.7295H39.3513C39.8289 20.7295 40.2164 21.117 40.2164 21.5945V32.6809",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4746 19H36.5618C37.0393 19 37.4268 19.3875 37.4268 19.865V34.5837",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2703 41.1H20.865C20.3875 41.1 20 40.7125 20 40.235V23.5605",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4205 46H34.5358C33.2846 46 32.27 44.9855 32.27 43.7343V36.8498C32.27 35.5985 33.2846 34.584 34.5358 34.584H41.4205C42.6718 34.584 43.6863 35.5985 43.6863 36.8498V43.7343C43.6863 44.9855 42.6718 46 41.4205 46Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.5617L24.5695 19V22.6967C24.5695 23.1742 24.1825 23.5613 23.7049 23.5613H20V23.5617Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2997 23.1859H27.4738C26.982 23.1859 26.5835 22.7874 26.5835 22.2956V22.2936C26.5835 21.8018 26.982 21.4033 27.4738 21.4033H31.2997C31.7915 21.4033 32.19 21.8018 32.19 22.2936V22.2956C32.19 22.7874 31.7915 23.1859 31.2997 23.1859Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0767 26.6367H34.3675",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0767 29.0537H34.3675",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2593 31.4697H34.3678",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0767 31.4697H30.3463",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0762 33.8828H27.9994",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0767 36.2998H27.9999",
    stroke: "#DA867D",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7745 38.627L37.4497 41.9517L35.8672 40.3692",
    stroke: "#1E247E",
    strokeWidth: 0.778352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSubmittedIcon);
export default __webpack_public_path__ + "static/media/BankSubmittedIcon.1dfc29b315e2a609b0a7f51a61555f26.svg";
export { ForwardRef as ReactComponent };